import { Component } from '@angular/core';
import { config } from './firebase-config';
import { NotificationTokenModel } from './shared/models/response-model';
import { NotificationService } from './shared/services/notification.service';
import { NavigationHistoryService } from './core/services/navigation-history.service';
import "firebase/compat/messaging";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import * as foo from "firebase/messaging";



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Shipping Market Place';
  tokenSend: any;
  messaging
  constructor(
    private notificationService: NotificationService,
    // Injecting NavigationHistoryService here ensures route history tracking
    // starts at application bootstrap, before any lazy-loaded module is loaded.
    private _navigationHistoryService: NavigationHistoryService
  ) { }

   ngOnInit() {
    this.messaging = getMessaging(config)
    window.addEventListener("beforeunload", () =>  {
      //this._localStorageService.deleteValueByKey('userToken');
      //window.localStorage.removeItem('userToken')
    });

    this.displayNotification();
    this.listenForForegroundMessages();
  }

  displayNotification() {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getToken(this.messaging, {
          vapidKey:   
            "BOu_Z5BiZ7aJ6LMpaXu1-JIrr1pxyEbT6LEDF_x6jbW-e_eCvfaHXIfVeTq3peNCSWqhOqZ-4-shmxEZlSNUKh0",
        })
          .then((currentToken) => {
            if (currentToken && localStorage.getItem('userToken')) {
              let token = localStorage.getItem('notificationToken')
                  if (!token) {
                      this.tokenSend = currentToken
                      localStorage.setItem('notificationToken', currentToken);
                      this.sendToken()
                    
                  } else if (token!=currentToken) {
                    this.tokenSend = currentToken
                    localStorage.setItem('notificationToken', currentToken);
                    this.sendToken();
                  } else {
                      return;
                      
                  }
              
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
              // ...
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
            // ...
          });
      } else {
        console.log("Unable to get permission to notify.");
      }
    });
     
  }

  listenForForegroundMessages() {
    if (!this.messaging) {
      return;
    }

    onMessage(this.messaging, (payload) => {
      const title = payload?.notification?.title || 'Notification';
      const body = payload?.notification?.body || payload?.data?.message || payload?.data?.body || '';
      if (Notification.permission === 'granted') {
        new Notification(title, {
          body,
          icon: payload?.notification?.icon,
        });
      }

      const notificationPayload = payload?.data ? payload.data : {
        ...payload?.notification,
        ...payload?.data
      };
      this.notificationService.pushRealtimeNotification(notificationPayload);
      this.notificationService.getNotification().subscribe({
        next: () => {
          this.notificationService.refreshNotifications();
        },
        error: (err) => {
          console.error('Failed to refresh notifications after Firebase message', err);
        }
      });
    });
  }

  sendToken() {
    if (this.tokenSend) {
      let notificationModel = new NotificationTokenModel();
      notificationModel.os = "web";
      notificationModel.token = this.tokenSend;
      this.notificationService.sendToken(notificationModel).subscribe((res) => {
        if (res.statusCode === 200) {
          console.log('Success')
        }
      })
    }
  }
}
